import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { onPlayPause } from 'Actions';
// import { isSameTrackAndPlaying } from 'Utils';
import { SongControlBar, UserStoryCard, DownloadButton } from 'Elements';
import styles from 'partials/song-card.module.scss';

export const SongCard = ({ className, song }) => {
	const dispatch = useDispatch();
	const track = useSelector((state) => state.player);
	const cardClass = cx(className, styles.card);

	// const isPlaying = isSameTrackAndPlaying(
	// 	track.activeTrackId,
	// 	song.file_id,
	// 	track.isPlaying
	// );

	const isSameTrack = (songId) => {
		return track.activeTrackId === songId;
	};

	const handlePlayPause = () => {
		dispatch(onPlayPause(song));
	};

	return (
		<div className={cardClass}>
			<div
				className={styles.back}
				style={{
					width: isSameTrack(song.file_id)
						? track.progressCompleted + '%'
						: 0
				}}
			/>
			<div className={styles.body}>
				<div className={styles.audio}>
					<SongControlBar size={18} song={song} />
				</div>
				<h3
					className={styles.title}
					title={song.title || song.file_title}
					onClick={handlePlayPause}
					onKeyPress={handlePlayPause}
					role="presentation">
					{song.title || song.file_title}
				</h3>
				<div className={styles.meta}>
					<UserStoryCard user={song.user} />
					<DownloadButton
						url={song?.file_url?.origin}
						size={song.file_size}
					/>
				</div>
			</div>
		</div>
	);
};
